import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import titleize from 'underscore.string/titleize';
import { houseKeeping as statusConfig } from '../config/service-options';
import { localize, t } from '../i18n';

const HousekeepingBadge = function HousekeepingBadge(props) {
  const {
    className,
    labelClassName,
    label,
  } = props;
  let {
    status,
  } = props;

  const wrapperClasses = ['uk-grid'];
  const labelClasses = ['uk-width-small-1-1'];
  const badgeClasses = ['uk-badge'];
  if (!status) {
    status = 'unknown';
  }
  let statusLabel = titleize(status.replace(/_/g, ' '));
  const statusCfg = _.find(statusConfig, { value: status });

  if (statusCfg) {
    badgeClasses.push(statusCfg.badgeCls);
    statusLabel = statusCfg.label;
  }

  if (className) {
    wrapperClasses.push(className);
  }

  if (labelClassName) {
    labelClasses.push(labelClassName);
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      <div className={labelClasses.join(' ')}>{props.t(label)}</div>
      <div className="uk-width-small-1-1">
        <span className={badgeClasses.join(' ')}>{props.t(statusLabel)}</span>
      </div>
    </div>
  );
};

HousekeepingBadge.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.string,
  t: PropTypes.func.isRequired,
};

HousekeepingBadge.defaultProps = {
  label: t('Housekeeping Status'),
  status: 'unknown',
};

export default localize(HousekeepingBadge);



// WEBPACK FOOTER //
// ./src/components/HousekeepingBadge.js